export default __webpack_public_path__ + "assets/tutorial-move_around.json";